import React from 'react';
import UserAPI from './UserAPI';
import { useState } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { primaryColor, secondaryColor } from '../utils/DisplaySettings';

const confirmationMessagePlacholder = 'Fit the vibe to gain points';

const Impressions = ({ sessionName }) => {
    const impressions_map = {
        "energizing": {label: "energizing", emoji: "⚡"},
        "amusing": {label: "amusing", emoji: "😄"},
        "joyful": {label: "joyful", emoji: "🌟"},
        "beautiful": {label: "beautiful", emoji: "✨"},
        "calm": {label: "calm", emoji: "😌"},
        "sad": {label: "sad", emoji: "💔"},
        "dreamy": {label: "dreamy", emoji: "🌙"},
        "tense": {label: "tense", emoji: "😰"},
        "amazing": {label: "amazing", emoji: "😲"}
    };
    const impressions_types = Object.keys(impressions_map);
    
    const [confirmationMessage, setConfirmationMessage] = useState(confirmationMessagePlacholder);
    const [impressionValues, setImpressionValues] = useState(
        Object.fromEntries(impressions_types.map(type => [type, 0.0]))
    );

    const toggleImpression = (type) => {
        setImpressionValues(prev => ({
            ...prev,
            [type]: prev[type] === 0.0 ? 100.0 : 0.0
        }));
    };

    const sendImpression = async () => {
        const idToken = localStorage.getItem('idToken');
        
        const bodyData = JSON.stringify({
            'request_type': 'user',
            'sessionname': sessionName,
            'user_request_type': 'impression',
            'idToken': idToken,
            ...Object.fromEntries(
                Object.entries(impressionValues).map(([key, value]) => [key, parseFloat(value)])
            )
        });

        await UserAPI(bodyData);
        if (!idToken) {
            setConfirmationMessage("Login needed");
        } else {
            setConfirmationMessage("Shared with the crowd!");
            // Reset all impression values to 0
            setImpressionValues(
                Object.fromEntries(impressions_types.map(type => [type, 0.0]))
            );
        }
        setTimeout(() => {
            setConfirmationMessage(confirmationMessagePlacholder);
        }, 2000);
    };

    return (
        <div>
            <Row className="justify-content-center mb-2">
                <Col xs="auto">
                    <Button 
                        variant="outline-light"
                        onClick={sendImpression}
                    >
                        Send Impressions
                    </Button>
                </Col>
            </Row>
            
            {confirmationMessage && (
                <Row className="justify-content-center mb-2">
                    <Col xs="auto">
                        <div className="text-center" style={{ fontSize: 'clamp(0.75rem, 1.75vw, 1rem)' }}>
                            {confirmationMessage}
                        </div>
                    </Col>
                </Row>
            )}

            <Row className="justify-content-center">
                {[0, 1, 2].map(rowIndex => (
                    <Row key={rowIndex} className="justify-content-center mb-1">
                        {[0, 1, 2].map(colIndex => {
                            const index = rowIndex * 3 + colIndex;
                            if (index >= impressions_types.length) return null;
                            const type = impressions_types[index];
                            return (
                                <Col xs={4} key={colIndex} className="text-center px-1">
                                    <Button
                                        variant="outline-light"
                                        onClick={() => toggleImpression(type)}
                                        style={{ 
                                            width: '100%',
                                            backgroundColor: impressionValues[type] === 100.0 ? primaryColor : 'transparent',
                                            transition: 'all 0.3s ease',
                                            boxShadow: impressionValues[type] === 100.0 ? `0 0 0.8rem ${primaryColor}` : 'none',
                                            display: 'flex',
                                            alignItems: 'center',
                                            height: '2.rem',
                                            justifyContent: 'center',
                                            border: '2px solid white',
                                            borderRadius: '4px'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (impressionValues[type] !== 100.0) {
                                                e.currentTarget.style.boxShadow = `0 0 0.8rem rgba(255, 255, 255, 0.5)`;
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (impressionValues[type] !== 100.0) {
                                                e.currentTarget.style.boxShadow = 'none';
                                            }
                                        }}
                                    >
                                        {/* Mobile view (emoji only) */}
                                        <span className="d-block d-md-none">
                                            <span style={{ fontSize: '1.2rem' }}>{impressions_map[type].emoji}</span>
                                        </span>
                                        
                                        {/* Tablet view (stacked emoji and label) */}
                                        <div className="d-none d-md-flex d-lg-none flex-column align-items-center">
                                            <span style={{ fontSize: '1.0rem' }}>{impressions_map[type].emoji}</span>
                                            <span style={{ fontSize: '0.6rem' }}>
                                                {impressions_map[type].label}
                                            </span>
                                        </div>
                                        
                                        {/* Desktop view (emoji and label inline) */}
                                        <span className="d-none d-lg-inline">
                                            {impressions_map[type].emoji} {impressions_map[type].label}
                                        </span>
                                    </Button>
                                </Col>
                            );
                        })}
                    </Row>
                ))}
            </Row>
        </div>
    );
};

export default Impressions;